/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargingConfiguration } from '../../models/charging-configuration';

export interface ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain$Params {
  parkingPlaceId?: number;
}

export function apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain(http: HttpClient, rootUrl: string, params?: ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
  const rb = new RequestBuilder(rootUrl, apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain.PATH, 'get');
  if (params) {
    rb.query('parkingPlaceId', params.parkingPlaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargingConfiguration>;
    })
  );
}

apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain.PATH = '/api/ChargingConfiguration/GetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceId';
